import * as _ from "lodash";
import Select from "react-select";
import React from "react";

const SelectField = (props) => {
    const { data } = props;

    const options = [];
    _.forEach(Object.keys(data), key => {
        options.push({ value: key, label: data[key] });
    });

    return (
        <Select
            options={options}
            clearable={false}
            placeholder='Choose option'
            {...props}
            onBlur={() => props.onBlur()}
            onChange={newValue => newValue ? props.onChange(newValue.value) : props.onChange('')}
        />
    )
}

export default SelectField;